<div class="message-wrapper">
    <mat-card appearance="outlined">
        <!-- prettier-ignore -->
        <div class="hydrao-card-title" i18n="@@register.confirmation.accountActivated">Account activated</div>
        <!-- prettier-ignore -->
        <div i18n="@@register.confirmation.canLogIn">Your account is now active, you can log in.</div>
        <!-- prettier-ignore -->
        <button mat-flat-button color="primary"  i18n="@@register.confirmation.goToLoginPage" routerLink="/login">Go to login page</button>
    </mat-card>
</div>